
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enquiryPage",
      function () {
        return require("private-next-pages/enquiryPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enquiryPage"])
      });
    }
  